import * as React from 'react';

import { environment } from '@doltech/core/lib/environment/environment';
import { getPageDisplayNameByKey } from '@doltech/utils/lib/enum/PageDisplayNameEnum';
import { getPublicUrlPath } from '@doltech/utils/lib/location';

export const useLandingJsonLdSchema = ({ urlInfo, type }) => {
  const pageUrl = environment.REACT_APP_DOL_CORP_WEBSITE_HOST_NAME + urlInfo.url;
  const heading = getPageDisplayNameByKey(urlInfo.type);

  const schemaList = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      '@id': 'https://www.dolenglish.vn/#organization',
      url: 'https://www.dolenglish.vn/',
      name: 'DOL IELTS Đình Lực - Luyện thi IELTS',
      mainEntityOfPage: 'https://www.dolenglish.vn/',
      description:
        'DOL IELTS Đình Lực là Trung tâm luyện thi IELTS Tư duy đầu tiên tại Việt Nam, giáo viên chuyên môn cao & nền tảng tự học IELTS Online chất lượng',
      sameAs: [
        'https://www.facebook.com/dolenglish.ieltsdinhluc/',
        'https://www.youtube.com/channel/UCEhPLLt928jxgOGDtyzgV9g',
        'https://www.instagram.com/dol.vn_ieltsdinhluc/',
      ],
      logo: {
        '@type': 'ImageObject',
        '@id': 'https://www.dolenglish.vn/#logo',
        inLanguage: 'vi-VN',
        url: 'https://asset.dolenglish.vn/7Vun9ltNRU2VTpAPHuFg',
        width: '105',
        height: '40',
        caption: 'Logo dolenglish.vn',
        image: { '@id': 'https://www.dolenglish.vn/#logo' },
      },
      address: {
        '@type': 'PostalAddress',
        '@id': 'https://www.dolenglish.vn/#address',
        addressLocality: 'Quận 10',
        addressCountry: 'VIỆT NAM',
        addressRegion: 'Hồ Chí Minh',
        postalCode: '700000',
        streetAddress: '458/14 Ba Tháng Hai, Phường 12, Quận 10, Thành phố Hồ Chí Minh',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        '@id': 'https://www.dolenglish.vn/#contactPoint',
        telephone: '+84 356307668',
        email: 'dol.vn.social@gmail.com',
      },
      legalName: 'CÔNG TY TNHH DOL ENGLISH',
      foundingDate: '2018',
      location: {
        '@type': 'Place',
        '@id': 'https://www.dolenglish.vn/#location',
        address: { '@id': 'https://www.dolenglish.vn/#address' },
        hasMap: [
          'https://www.google.com/maps/place/DOL+IELTS+%C4%90%C3%ACnh+L%E1%BB%B1c+-+H%E1%BB%8Dc+Vi%E1%BB%87n+Ti%E1%BA%BFng+Anh+T%C6%B0+Duy+%C4%91%E1%BA%A7u+ti%C3%AAn+t%E1%BA%A1i+Vi%E1%BB%87t+Nam/@10.7690646,106.6678783,15z/data=!4m6!3m5!1s0x31752fa0c8f8a1b9:0x9db957debb7acb62!8m2!3d10.7690646!4d106.6678783!16s%2Fg%2F11hyxt33rj',
          'https://search.google.com/local/writereview?placeid=ChIJuaH4yKAvdTERYst6u95XuZ0',
          'https://www.google.com/maps?cid=11365211748785900386',
        ],
      },
    },
    {
      '@context': 'https://schema.org/',
      '@type': 'WebPage',
      '@id': `${pageUrl}#webpage`,
      url: pageUrl,
      inLanguage: 'vi-VN',
      name: heading,
      isPartOf: {
        '@type': 'WebSite',
        '@id': 'https://www.dolenglish.vn/#website',
      },
      image: {
        '@type': 'ImageObject',
        '@id': `${pageUrl}#primaryimage`,
        url: `${getPublicUrlPath(urlInfo.thirdParty?.fileInfo?.path)}`,
        caption: urlInfo.thirdParty?.fileInfo?.caption,
      },
      primaryImageOfPage: {
        '@id': `${pageUrl}#primaryimage`,
      },
      datePublished: urlInfo.createdAt,
      dateModified: urlInfo.lastModifiedAt,
      description: urlInfo.dol?.description,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'CreativeWorkSeries',
      url: pageUrl,
      '@id': `${pageUrl}#CreativeWorkSeries`,
      name: type === 'blog' ? heading : urlInfo.dol?.title,
      headline: urlInfo.dol?.title,
      description: urlInfo.dol?.description,
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: (Math.random() * 0.5 + 4.5).toFixed(1),
        bestRating: 5,
        ratingCount: Math.floor(Math.random() * 201) + 50,
      },
    },
    {
      '@context': 'http://schema.org/',
      '@type': 'WPHeader',
      '@id': `${pageUrl}/#header`,
    },
    {
      '@context': 'http://schema.org/',
      '@type': 'SiteNavigationElement',
      '@id': `${pageUrl}/#navigation`,
    },
    {
      '@context': 'http://schema.org/',
      '@type': 'WPFooter',
      '@id': `${pageUrl}/#footer`,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'EducationalOrganization',
      image: 'https://media.dolenglish.vn/PUBLIC/MEDIA/Logo_0efdf497dd.png',
      founder: {
        '@type': 'Person',
        name: 'Lê Đình Lực',
        URL: '',
        Address: '458/14 Hẻm 458 Ba Tháng Hai, Phường 12, Quận 10, Thành phố Hồ Chí Minh',
      },
      additionalType: [
        'https://www.facebook.com/dolenglish.ieltsdinhluc/',
        'https://twitter.com/english_dol',
        'https://www.instagram.com/dol_english_vn/',
        'https://dolenglish.tumblr.com/',
        'https://vn.linkedin.com/in/dol-english-57a826175',
        'https://about.me/dol_english',
        'https://iheart.com/podcast/106434637/',
        'https://open.spotify.com/show/0O16qZXtG1ygoJFYU82UBZ',
        'https://www.youtube.com/channel/UCEhPLLt928jxgOGDtyzgV9g',
      ],
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
          opens: '9:00:00',
          closes: '21:00:00',
        },
      ],
      sameAs: [
        'https://tuoitre.vn/tung-ngan-tieng-anh-thanh-cong-ngay-khi-khoi-nghiep-voi-phuong-phap-hoc-van-nguoi-me-20220309112543695.htm',
        'https://vnexpress.net/hoc-tieng-anh-dua-tren-toan-tu-duy-va-tri-tue-nhan-tao-3967889.html',
        'https://masothue.com/0315174306-cong-ty-tnhh-dol-english',
        'https://baodautu.vn/le-dinh-luc-nha-sang-lap-dolvn-hoc-tieng-anh-de-dang-hon-voi-cong-nghe-phuong-phap-tu-duy-d161029.html',
      ],
      url: 'https://www.dolenglish.vn/',
      '@id': 'kg:/g/11hyxt33rj ',
      potentialAction: {
        result: {
          '@type': 'Reservation',
          name: 'Liên hệ',
        },
        '@type': 'ReserveAction',
        target: {
          '@type': 'EntryPoint',
          inLanguage: 'vn',
          actionPlatform: [
            ' http://schema.org/DesktopWebPlatform',
            'http://schema.org/IOSPlatform',
            'http://schema.org/AndroidPlatform',
          ],
          urlTemplate: 'https://www.dolenglish.vn/lien-he',
        },
      },
      name: 'Trung tâm luyện thi IELTS DOL Đình Lực',
      alternatename: 'Luyện thi IELTS Tiếng Anh Tư Duy | DOL IELTS Đình Lực',
      description:
        'DOL IELTS Đình Lực là Trung tâm luyện thi IELTS Tư duy đầu tiên tại Việt Nam, giáo viên chuyên môn cao nền tảng tự học IELTS Online chất lượng',
      disambiguatingdescription:
        'Hơn 9000 thành viên hoạt động sôi nổi cùng học hỏi kinh nghiệm luyện thi PTE, mẹo và chiến thuật làm bài hiệu quả từ hàng nghìn học viên đã đạt điểm cao và thành công với PTE HELPER.',
      logo: {
        type: 'ImageObject',
        '@id': 'https://media.dolenglish.vn/PUBLIC/MEDIA/Logo_0efdf497dd.png',
        url: 'https://media.dolenglish.vn/PUBLIC/MEDIA/Logo_0efdf497dd.png',
      },
      hasMap: [
        'https://goo.gl/maps/5U466qvDNzaZNkcj7',
        'https://goo.gl/maps/5EuA1xsj9sikURqC8',
        'https://goo.gl/maps/9eCUMMVXQyFzYsTq5',
        'https://goo.gl/maps/d86upZYUNESHRPRS9',
        'https://goo.gl/maps/Uc64CmnA13kC3RJg6',
        'https://goo.gl/maps/qfhyhGsdqNZR6wWV9',
        'https://goo.gl/maps/BcPwUpfy86FfuTaz5',
      ],
      mainEntityOfPage: 'https://www.dolenglish.vn/about-us',
      email: ['info@dolenglish.vn'],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: ['1800 96 96 39'],
        contactType: 'Customer support',
        email: 'info@dolenglish.vn',
      },
      telephone: '1800 96 96 39',
      address: [
        {
          '@type': 'PostalAddress',
          addressCountry: 'Việt Nam',
          addressLocality: 'Quận 10',
          addressRegion: 'Hồ Chí Minh',
          streetAddress: '458/14 Hẻm 458 Ba Tháng Hai, Phường 12',
          postalCode: '700000',
        },
        {
          '@type': 'PostalAddress',
          addressCountry: 'Việt Nam',
          addressLocality: 'Quận 4',
          addressRegion: 'Hồ Chí Minh',
          streetAddress: '219 Khánh Hội, Phường 5, Quận 4',
          postalCode: '700000',
        },
        {
          '@type': 'PostalAddress',
          addressCountry: 'Việt Nam',
          addressLocality: 'Quận 6',
          addressRegion: 'Hồ Chí Minh',
          streetAddress: '16 Đường số 3, Phường 11, Quận 6',
          postalCode: '700000',
        },
        {
          '@type': 'PostalAddress',
          addressCountry: 'Việt Nam',
          addressLocality: 'Quận 9',
          addressRegion: 'Hồ Chí Minh',
          streetAddress: '25b Đường Lê Văn Việt, Hiệp Phú, Quận 9',
          postalCode: '700000',
        },
        {
          '@type': 'PostalAddress',
          addressCountry: 'Việt Nam',
          addressLocality: 'Quận Bình Thạnh',
          addressRegion: 'Hồ Chí Minh',
          streetAddress: '302 Nguyễn Văn Đậu, Bình Thạnh',
          postalCode: '700000',
        },
        {
          '@type': 'PostalAddress',
          addressCountry: 'Việt Nam',
          addressLocality: 'Quận Gò Vấp',
          addressRegion: 'Hồ Chí Minh',
          streetAddress: '22 Đường số 3, Cityland Park Hills',
          postalCode: '700000',
        },
        {
          '@type': 'PostalAddress',
          addressCountry: 'Việt Nam',
          addressLocality: 'Quận Tân Bình',
          addressRegion: 'Hồ Chí Minh',
          streetAddress: '18H Cộng Hòa, Phường 4',
          postalCode: '700000',
        },
      ],
      foundingLocation: {
        '@type': 'Place',
        name: 'Hồ Chí Minh',
        url: ' https://en.wikipedia.org/wiki/Ho_Chi_Minh_City',
        address: 'Việt Nam',
      },
      geo: [
        {
          '@type': 'GeoCoordinates',
          latitude: '10.7690646',
          longitude: '106.6678783',
        },
        {
          '@type': 'GeoCoordinates',
          latitude: '10.7582976',
          longitude: '106.6991462',
        },
        {
          '@type': 'GeoCoordinates',
          latitude: '10.745801',
          longitude: '106.63401',
        },
        {
          '@type': 'GeoCoordinates',
          latitude: '10.8452894',
          longitude: '106.7793322',
        },
        {
          '@type': 'GeoCoordinates',
          latitude: '10.8147676',
          longitude: '106.6944158',
        },
        {
          '@type': 'GeoCoordinates',
          latitude: '10.8343478',
          longitude: '106.6705856',
        },
        {
          '@type': 'GeoCoordinates',
          latitude: '10.8013588',
          longitude: '106.6552402',
        },
      ],
      legalName: 'Trung tâm luyện thi IELTS DOL Đình Lực',
      foundingDate: '2018',
      numberOfEmployees: '150',
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        itemListElement: [
          {
            '@type': 'Offer',
            name: 'Khóa học IELTS',
            itemOffered: 'Service',
            url: 'https://www.dolenglish.vn/khoa-hoc-ielts',
          },
          {
            '@type': 'Offer',
            name: 'IELTS cấp tốc',
            itemOffered: 'Service',
            url: 'https://www.dolenglish.vn/ielts-cap-toc',
          },
          {
            '@type': 'Offer',
            name: 'IELTS cơ bản',
            itemOffered: 'Service',
            url: 'https://www.dolenglish.vn/ielts-co-ban',
          },
          {
            '@type': 'Offer',
            name: 'IELTS nâng cao',
            itemOffered: 'Service',
            url: 'https://www.dolenglish.vn/ielts-nang-cao',
          },
          {
            '@type': 'Offer',
            name: 'IELTS ONLINE & 1-1',
            itemOffered: 'Service',
            url: 'https://www.dolenglish.vn/hoc-ielts-online',
          },
        ],
      },
      areaServed: {
        '@type': 'Country',
        url: 'https://www.wikidata.org/wiki/Q881',
        name: 'Việt Nam',
      },
    },
  ];

  return schemaList.map((schema, idx) => (
    <script
      key={`script-${idx}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  ));
};
